import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center text-zinc-500" data-testid="protected-loading">
      Loading…
    </div>
  );
  if (!user) {
    // Operator-side routes that must login. Redirect to login with from state.
    return <Navigate to="/admin" replace state={{ from: loc }} />;
  }
  if (roles && roles.length && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protected-forbidden">
        <div className="text-center">
          <h2 className="font-anton text-4xl uppercase tracking-tighter text-red-500">No Access</h2>
          <p className="text-zinc-400 mt-2">Your role: <span className="text-white">{user.role}</span></p>
        </div>
      </div>
    );
  }
  return children;
}
